//core
import React from "react";
import { Alert, Typography } from "@mui/material";
import Button from "../Buttons/Button";

//styles
import { useStyles } from "./styles";

interface IInfoAlertProps {
  text: React.ReactNode;
  actionLabel?: React.ReactNode;
  actionDisabled?: boolean;
  className?: string;
  onAction?: () => void;
}

const InfoAlert: React.FC<IInfoAlertProps> = ({
  text,
  actionLabel,
  onAction,
  actionDisabled = false,
  className = '',
}): JSX.Element => {
  const styles = useStyles();

  const hasAction = !!actionLabel && !!onAction;

  return (
    <Alert
      severity="info"
      className={`${styles.root} ${hasAction ? styles.withAction : ''} ${className}`}
      action={hasAction ? (
        <Button
          disableElevation
          size="small"
          type="button"
          variant="text"
          color="info"
          className={styles.button}
          disabled={actionDisabled}
          onClick={onAction}
        >
          {actionLabel}
        </Button>
      ) : undefined}
    >
      <Typography variant="body2" color="inherit">
        {text}
      </Typography>
    </Alert>
  );
};

export default InfoAlert;
